module.exports = __webpack_public_path__ + "static/media/Calendar-unselected.8e6194ea.svg";